// extracted by mini-css-extract-plugin
export default {"layout":"Callbacks_layout__Zc+v2","sidebar":"Callbacks_sidebar__-6dcM","main":"Callbacks_main__jWCR-"};